import React, { useEffect, useRef, useState } from "react";
import {
  EnhancedBanner,
  Hero,
  HowItWorks,
  Modes,
  InterviewSampleModal,
  PreInterviewModal,
  Pricing,
} from "./components";
// import Features from "./components/Features";
import SEOMeta from "../../components/SEOMeta";
import { WebPaths } from "../../../../routes/data";
import { SVLogoSquare } from "../../../../images";
import useOpener from "../../../../hooks/useOpener";
import ReserveFreeTrialModal from "../../landing page/components/ReserveFreeTrialModal";
import storage from "../../../../utils/storage";
import { hasFibiFreeTrialText } from "../../landing page/components/data";

const FiBi = () => {
  const { onClose, onOpen, open } = useOpener();
  const hasFibiFreeTrial = storage.get(hasFibiFreeTrialText);
  const [openSampleModal, setOpenSampleModal] = useState(false);
  const [openPreInterviewModal, setOpenPreInterviewModal] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  useEffect(() => {
    setOpenPreInterviewModal(true);

    return () => {
      setOpenPreInterviewModal(false);
    };
  }, []);

  // The "Reserve your free trial" modal should surface only ONCE per page
  // load — after any intro modals are dismissed — and must never re-open on
  // cursor movement (e.g. when the mouse leaves the window toward the tabs or
  // URL bar). Once the user closes it, it stays closed until the next reload.
  const hasAutoOpenedReserve = useRef(false);

  useEffect(() => {
    if (hasAutoOpenedReserve.current) return; // already shown this page load
    if (hasFibiFreeTrial) return; // user already reserved — never show
    if (openSampleModal || openPreInterviewModal) return; // wait for intro modals

    hasAutoOpenedReserve.current = true;
    onOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFibiFreeTrial, openSampleModal, openPreInterviewModal]);

  const onClosePreInterview = () => {
    setOpenPreInterviewModal(false);
  };

  const [activeTab, setActiveTab] = useState<"individuals" | "businesses">(
    "individuals",
  );

  return (
    <>
      <div className="bg-white-f9 relative overflow-hidden">
        <SEOMeta
          title="FiBi AI Assistant | Your Personalized Interview Trainer"
          description="Meet FiBi, your AI-powered assistant for visa risk checks, form reviews, and interview simulations. Get the expert guidance you need to navigate the visa application process."
          canonicalUrl={`https://www.seamlessvisa.com${WebPaths.FiBiAi}`}
          url={`https://www.seamlessvisa.com${WebPaths.FiBiAi}`}
          siteName="SeamlessVisa"
          publisher="https://www.facebook.com/share/1BhLA5r2Ac/"
          imageUrl={SVLogoSquare}
          imageWidth="1920"
          imageHeight="1080"
          imageType="image/png"
          twitterCard="summary_large_image"
          twitterTitle="FiBi AI Assistant | SeamlessVisa"
          twitterDescription="Meet FiBi, your AI-powered assistant for visa risk checks, form reviews, and interview simulations. Get the expert guidance you need to navigate the visa application process."
          twitterSite="@SeamlessVisa_"
        />
        {/* banner */}
        {isBannerVisible && (
          <EnhancedBanner absolute onClose={() => setIsBannerVisible(false)} />
        )}
        <Hero />

        {/* <FiBiChoices /> 
        <FibiTestimonials />*/}
        <HowItWorks />
        <Modes />
        <div id="pricing">
          <Pricing activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>

      {open && <ReserveFreeTrialModal onClose={onClose} />}
      {openPreInterviewModal && (
        <PreInterviewModal
          onClose={onClosePreInterview}
          onOpenMainModal={() => {
            onClosePreInterview();
            setOpenSampleModal(true);
          }}
        />
      )}
      {openSampleModal && (
        <InterviewSampleModal onClose={() => setOpenSampleModal(false)} />
      )}
    </>
  );
};

export default FiBi;
